<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("download.title") }}</h5>
    <Downloadform :tenant-id="tenantId" :project-id="projectId"></Downloadform>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import Downloadform from "@/components/download/downloadform.vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
    Downloadform,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const breadcrumb = ref([
      { title: "Home", path: "/" },
      { title: "Download", path: "#", isActive: true },
    ]);
    // const tenantId = computed(() => store.getters.tenantId);
    // const projectId = computed(() => route.params.projectId);

    return {
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
      breadcrumb,
    };
  },
};
</script>
